// Pure manual interaction guard. Flags/reports from automatic CHECK grant no authority.
export function hasUnresolvedOrderAction(row) {
    const state=(row?.preExportCheck || row?.automaticCheck)?.state;
    return ["checking","queued","export","delete"].includes(state);
}
export function canStartManualCheck(row, canonicalStatus, busy=false) {
    return !busy && row?.supplierOrderType === "Bulk Order" && canonicalStatus === "Ready to export" &&
        !hasUnresolvedOrderAction(row);
}
